import {ShowIngredientComponent} from "../pages/administration/kitchen/modal/show-ingredient/show-ingredient.component";
import {NewIngredientComponent} from "../pages/administration/kitchen/modal/new-ingredient/new-ingredient.component";
import {ShowAllergenComponent} from "../pages/administration/kitchen/modal/show-allergen/show-allergen.component";
import {NewAllergenComponent} from "../pages/administration/kitchen/modal/new-allergen/new-allergen.component";
import {
    NewNecessaryEquipmentComponent
} from "../pages/administration/kitchen/modal/new-necessary-equipment/new-necessary-equipment.component";
import {
    ShowNecessaryEquipmentComponent
} from "../pages/administration/kitchen/modal/show-necessary-equipment/show-necessary-equipment.component";
import {
    ShowBaseKitchenComponent
} from "../pages/administration/kitchen/modal/show-base-kitchen/show-base-kitchen.component";
import {
    NewBaseKitchenComponent
} from "../pages/administration/kitchen/modal/new-base-kitchen/new-base-kitchen.component";
import {Type} from "@angular/core";
import {MbColDefinition, MbColInput} from "../components/mb-datatable/models/mb-datatable.model";
import {MbDatatablesTemplate} from "../components/mb-datatable/mb-datatables-template";

export class Constants {
    public static DEFAULT_RESERVATION_DURATION = 120;
    public static RESERVATION_RESTAURANT_HISTORY_ID_KEY = 'RESERVATION_RESTAURANT_HISTORY_ID_KEY';
    public static USE_TO_ALL_RESTAURANTS = 'USE_TO_ALL_RESTAURANTS';
    public static USER_REST_KEY = 'users_restaurants';
    public static DECLINE_TYPE = {
        DECLINE: 'DECLINE',
        DECLINE_AND_GENERATE: 'DECLINE_AND_GENERATE'
    };
    public static DEFAULT_LANGUAGE = 'hu';
    public static SYSTEM_ADMIN_RULE = 'superAdmin';
    public static ENVIRONMENT = 'DASHBOARD';
    public static ENVIRONMENTS = {
        dashboard: 'DASHBOARD',
        delivery: 'DELIVERY',
        shop: 'SHOP',
        reservation: 'RESERVATION',
        menu: 'MENU',
        email: 'EMAIL',
        'food-selector': 'FOODSELECTOR',
        'video-player': 'VIDEOPLAYER',
        error: 'ERROR',
        restaurant: 'RESTAURANT',
        banner: 'BANNER',
        mobile: 'MOBILEAPP',
    };
    public static SYSTEM_LANGUAGES = ['hu', 'en'];
    public static ATTACHMENT_REFRESH_EVENT_TYPES = {
        CHANGE_DATA: 'CHANGE_DATA'
    };
    public static ADDRESS_CONST = {
        COUNTRIES: [{id: 'HU', itemName: 'HU'}, {id: 'UK', itemName: 'UK'}],
        CITIES: [{id: 'BUDAPEST', itemName: 'BUDAPEST'}],
        ADDRESS_TYPES: [{id: 'ROAD', itemName: 'ROAD'}, {id: 'STREET', itemName: 'STREET'}, {
            id: 'CIRCLEROAD',
            itemName: 'CIRCLEROAD'
        }]
    };
    public static DELIVERY_TRACK_COLOR_MAP = {
        ORDERED: 'bg-red',
        CONFIRMED: 'bg-orange',
        IN_PROGRESS: 'bg-blue',
        DELIVERY_CONFIRMED: 'bg-yellow',
        ON_DELIVERY: 'bg-success',
        RECEIVED: 'bg-green'
    };
    public static RESERVATION_STATUS_COLOR_MAP = {
        DRAFT: 'bg-red',
        PENDING: 'bg-orange',
        ACCEPTED: 'bg-yellow',
        SUCCEEDED: 'bg-green',
        PAID: 'bg-blue',
        FULFILLED: 'bg-success',
        NOT_ARRIVED: 'bg-blue'
    };
    public static RESERVATION_STATUS_COLOR_MAP_FOR_RESERVATION_SALES_ANALYTICS = {
        DRAFT: 'rgba(245, 54, 92, 1)',
        PENDING: 'rgba(251, 99, 64, 1)',
        ACCEPTED: 'rgba(255, 214, 0, 1)',
        SUCCEEDED: 'rgba(50, 168, 52, 1)',
        PAID: 'rgba(66, 50, 168, 1)',
        FULFILLED: 'rgba(148, 50, 168, 1)',
        NOT_ARRIVED: 'rgba(94, 114, 228, 1)',
        DECLINE_BY_RESTAURANT: 'rgba(99, 97, 99, 1)',
        DECLINE_BY_GUEST: 'rgba(147, 145, 148, 1)',
    };
    public static PRODUCT_NAME_COLORS_FOR_VOUCHER_SALES_ANALYTICS = [
        'rgba(67, 71, 80, 1)',
        'rgba(198, 166, 100, 1)',
        'rgba(184, 183, 153, 1)',
        'rgba(108, 113, 86, 1)',
        'rgba(175, 43, 30, 1)',
        'rgba(69, 50, 46, 1)',
        'rgba(138, 149, 151, 1)',
        'rgba(247, 94, 37, 1)',
        'rgba(132, 195, 190, 1)',
        'rgba(0, 187, 45, 1)',
        'rgba(243, 165, 5, 1)',
        'rgba(215, 45, 10, 1)',
        'rgba(174, 160, 75, 1)',
        'rgba(189, 236, 182, 1)',
        'rgba(230, 214, 144, 1)',
        'rgba(49, 102, 80, 1)',
        'rgba(34, 113, 179, 1)',
        'rgba(211, 110, 112, 1)',
        'rgba(73, 126, 118, 1)',
        'rgba(108, 70, 117, 1)',
    ];
    public static EVENT_STATUS_COLOR_MAP = {
        DRAFT: 'bg-purple',
        PUBLISHED: 'bg-pink',
    };
    public static DELIVERY_TIMES = [
        {id: '12:00-14:00', itemName: '12:00-14:00'},
        {id: '15:00-17:00', itemName: '15:00-17:00'},
        {id: '18:00-20:00', itemName: '18:00-20:00'}
    ];
    public static STORAGE_KEYS = {
        LANGUAGE: 'LANGUAGE'
    };
    public static ORDER_PAYMENT_STAUS = {
        SUCCEEDED: 'Succeeded',
        CANCELED: 'Canceled',
        EXPIRED: 'Expired',
        PREPARED: 'Prepared',
        FULFILLED: 'fulfilled',
        NOTFULFILLED: 'notfulfilled'
    }
    public static FILTER_PERIOD = {
        HOUR: 'hour',
        DAY: 'day',
        MONTH: 'month',
        YEAR: 'year'
    };
    public static ORDER_TYPES = {
        DELIVERY: 'DELIVERY',
        SHOP: 'SHOP'
    };
    public static RESERVATION_VIEWS = {
        CALENDAR: 'calendar',
        TABLE: 'table'
    };
    public static RESERVATION_TYPES = {
        DELIVERY: 'DELIVERY',
        PERSONAL: 'PERSONAL',
        GROUP: 'GROUP',
        EXTRA: 'EXTRA'
    };
    public static PRODUCT_TYPE = {
        FOOD: 'FOOD',
        GIFT_CARD: 'GIFT_CARD',
        EVENT: 'EVENT',
        PRODUCT: 'PRODUCT',
        EXTRA: 'EXTRA',
        DRINK: 'DRINK',
        PACKAGE: 'PACKAGE',
        ADDITIONAL: 'ADDITIONAL',
        DIY_AT_HOME: 'DIY_AT_HOME',
        SPECIAL_EVENT: 'SPECIAL_EVENT',
    };
    public static VOUCHER_STATUSES = {
        USED: 'used',
        USABLE: 'usable',
        EXPIRED: 'expired',
        REJECT: 'rejected',
        RESEND: 'resend',
        FORWARDED: 'forwarded',
        CONVERTED: 'converted',
        PREPARED_FOR_TABLE: 'preparedForTable'
    };

    public static FEE_OPTION_TYPE = {
        VOUCHER: 'VOUCHER',
        MARKETING: 'MARKETING',
        FRANCHISE: 'FRANCHISE',
        GROUP_RESERVATION: 'GROUP_RESERVATION',
        HOME_DELIVERY: 'HOME_DELIVERY'
    };
    public static DISCOUNT_TYPE = {
        PERCENT: 'PERCENT',
        VALUE: 'VALUE'
    };

    public static OPENING_HOURS_ELEMENT_TYPE = {
        OPEN: 'OPEN',
        CLOSE: 'CLOSE'
    };
    public static HISTORY_STATUS_OPTIONS = [
        {label: 'enum.DRAFT', value: 'DRAFT'},
        {label: 'enum.PUBLISHED', value: 'PUBLISHED'},
        {label: 'enum.UNPUBLISHED', value: 'UNPUBLISHED'},
        {label: 'enum.DEPRECATED', value: 'DEPRECATED'},
    ];
    public static HISTORY_STATUSES = ['DRAFT', 'PUBLISHED', 'UNPUBLISHED', 'DEPRECATED'];
    public static HISTORY_STATUS_DRAFT = 'DRAFT';
    public static HISTORY_STATUS_PUBLISHED = 'PUBLISHED';
    public static HISTORY_STATUS_UNPUBLISHED = 'UNPUBLISHED';
    public static HISTORY_STATUS_DEPRECATED = 'DEPRECATED';
    public static PLACE_TYPES = {
        IN_RESTAURANT: 'IN_RESTAURANT',
        OUT_RESTAURANT: 'OUT_RESTAURANT'
    };
    public static ADDRESS_TYPES = {
        BASE: 'BASE'
    };
    public static EMAIL_TYPES = {
        general_information: {label: 'enum.email.general', required: true, isEdit: false},
        reservation: {label: 'enum.email.reservation', required: true, isEdit: false},
        event: {label: 'enum.email.event', required: true, isEdit: false},
        delivery: {label: 'enum.email.delivery', required: true, isEdit: false},
        other: {label: 'enum.email.other', required: true, isEdit: false}
    };
    public static EMAIL_TYPES_FOR_COMPANY = {
        general_information: {label: 'enum.email.general', required: true, isEdit: false},
        other: {label: 'enum.email.other', required: false, isEdit: false}
    };
    public static MEMBER_TYPES = [
        'OWNER',
        'MANAGER',
        'LEADER',
        'EMPLOYEE',
        'COOK',
        'WAITER',
        'OTHER'
    ];
    static FEE_PERIOD_TYPE = {
        DAY: 'DAY',
        MONTH: 'MONTH',
        WEEK: 'WEEK',
        YEAR: 'YEAR'
    };
    public static SYSTEM_LISTS = {
        DRINK_TYPE: 'DRINK_TYPE',
        PRODUCT_LEVEL: 'PRODUCT_LEVEL',
        DIY_TYPE: 'DIY_TYPE',
        INGREDIENT_TYPE: 'INGREDIENT_TYPE',
        STAFF_TYPE: 'STAFF_TYPE',
        DOCUMENT_TYPE: 'DOCUMENT_TYPE',
        NECESSARY_EQUIPMENT_TYPE: 'NECESSARY_EQUIPMENT_TYPE'
    };

    public static UNIT_TYPE = {
        KG: 'KG',
        AMOUNT: 'AMOUNT',
        PACKAGE: 'PACKAGE'
    };
    public static KITCHEN_ASPECT_TYPES = {
        PROBLEMATIC: 'PROBLEMATIC',
        SEASONAL: 'SEASONAL',
        PERISHABLE: 'PERISHABLE'
    };
    public static CORE_DATA_LIST = {
        localizations: 'localizations',
        currencies: 'currencies',
        languages: 'languages'
    };
    static NOTIFICATION_KEY = 'notification';
    static DRAFT_NOTIFICATION_KEY = 'draftReservation';
    static DASHBOARD_MESSAGE_COOKIE_KEY = 'dashboardMessage';
    static VIDEO_STREAM_TYPES = {
        DELIVERY: 'DELIVERY',
        RESTAURANT: 'RESTAURANT'
    };
    static VIDEO_EVENT_TYPES = {
        SUBTITLE: 'SUBTITLE',
        POPUP_IMAGE: 'POPUP_IMAGE'
    };
    static TEXT_STYLES = ['B', 'U', 'I'];
    static ACCEPT_TYPES = {
        IMG: 'image/*',
        PDF: 'application/pdf',
        VIDEO: 'video/*',
        ICON: 'image/svg+xml'
    };
    static KITCHEN_EXPERIENCE_LEVELS = {
        BEGINER: 'BEGINER',
        INTERMEDIATE: 'INTERMEDIATE',
        ADVANCED: 'ADVANCED',
        PROFESSIONAL: 'PROFESSIONAL'
    };
    static RECIPE_TYPE = {
        INDEPENDENT: 'INDEPENDENT',
        INGREDIENT: 'INGREDIENT',
        BOTH: 'BOTH'
    };
    static COOKING_UNITS = {
        TEASPOON: 'TEASPOON',
        DESSERTSPOON: 'DESSERTSPOON',
        TABLESPOON: 'TABLESPOON',
        CUP: 'CUP',
        GRAM: 'GRAM',
        DECILITER: 'DECILITER'
    };
    static CAPACITY_UNITS = {
        L: 'L',
        DL: 'DL',
        CL: 'CL',
        ML: 'ML'
    };
    static gradientBarChartConfiguration: any = {
        maintainAspectRatio: false,
        legend: {
            display: false
        },

        tooltips: {
            backgroundColor: '#f5f5f5',
            titleFontColor: '#333',
            bodyFontColor: '#666',
            bodySpacing: 4,
            xPadding: 12,
            mode: 'nearest',
            intersect: 0,
            position: 'nearest'
        },
        responsive: true,
        scales: {
            y:
                {
                    gridLines: {
                        drawBorder: false,
                        color: 'rgba(29,140,248,0.1)',
                        zeroLineColor: 'transparent'
                    },
                    ticks: {
                        suggestedMin: 0,
                        stepValue: 1,
                        padding: 1,
                        fontColor: '#9e9e9e'
                    },
                    // stacked: true
                }
            ,

            x:
                {
                    gridLines: {
                        drawBorder: false,
                        color: 'rgba(29,140,248,0.1)',
                        zeroLineColor: 'transparent'
                    },
                    ticks: {
                        padding: 20,
                        fontColor: '#9e9e9e'
                    },
                    stacked: true
                }
        }
    };
    static NOTE_TYPE = {
        SIMPLE_MESSAGE: 'SIMPLE_MESSAGE',
        FOR_USER: 'FOR_USER'
    };
    static NOTE_TYPES = {
        SIMPLE_MESSAGE: 'SIMPLE_MESSAGE',
        DECLINE_MESSAGE: 'DECLINE_MESSAGE',
        DECLINE_MESSAGE_TRANSLATABLE: 'DECLINE_MESSAGE_TRANSLATABLE',
        FOR_USER: 'FOR_USER'
    };
    static RESTAURANT_SERVICE_TYPES = {
        RESTAURANT: 'RESTAURANT',
        DELIVERY: 'DELIVERY',
        BOTH: 'BOTH'
    };
}

